var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncognito28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95352 3.83219C5.36773 3.24641 4.41798 3.24641 3.8322 3.83219C3.24641 4.41798 3.24641 5.36773 3.8322 5.95351L5.77705 7.89837C2.918 10.1295 1.25 12.9583 1.25 14C1.25 15.8214 6.35 23.1071 14 23.1071C16.0809 23.1071 17.973 22.5681 19.6252 21.7466L22.0465 24.1678C22.6323 24.7536 23.582 24.7536 24.1678 24.1678C24.7536 23.582 24.7536 22.6323 24.1678 22.0465L5.95352 3.83219ZM17.3213 19.4426L15.0333 17.1546C14.6657 17.2857 14.2698 17.3571 13.8571 17.3571C11.9241 17.3571 10.3571 15.7901 10.3571 13.8571C10.3571 13.4445 10.4285 13.0486 10.5597 12.681L8.55743 10.6787C7.96591 11.646 7.625 12.7832 7.625 14C7.625 17.5208 10.4792 20.375 14 20.375C15.2168 20.375 16.354 20.0341 17.3213 19.4426Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 14C20.375 14.197 20.3661 14.3919 20.3486 14.5844L24.1273 18.3632C25.8083 16.5742 26.75 14.7827 26.75 14C26.75 12.1786 21.65 4.89285 14 4.89285C12.9603 4.89285 11.9678 5.02742 11.0287 5.26454L13.4156 7.65142C13.6081 7.63393 13.803 7.625 14 7.625C17.5208 7.625 20.375 10.4792 20.375 14Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognito28);
export default __webpack_public_path__ + "static/media/incognito_28.ef449be5.svg";
export { ForwardRef as ReactComponent };